module.exports = __webpack_public_path__ + "img/eu.923826b8.svg";